export default "__VITE_ASSET__BU7EV9a8__"